<template>
  <div>
    <Divider dashed style="color:#fff">设置画面来源</Divider>
    <div class="p-b-10">
      <h4 class="workplatform-title m-t-10 m-b-20">画面来源设置</h4>
      <p class="text-orange">提示：选择“上刊中画面”，只能对单个任务进行设置</p>
      <div class="m-b-10">
        <RadioGroup
          v-model="type"
          vertical
          @on-change="changePictureSource"
        >
          <Radio
            v-for="item in pictureSourceArray"
            :key="'ps_'+item.value"
            :disabled="selectedTaskItemIds.length>1&&item.value===3"
            :label="item.value"
          >
            <span>{{item.name}}</span>
          </Radio>
        </RadioGroup>
      </div>
      <div v-if="type===3">
        <div class="m-b-10">
          <Input
            v-model="query.keyword"
            search
            enter-button
            placeholder="资源编号"
            @on-search="handleSearch"
          />
        </div>
        <div>
          <Table
            stripe
            :data="tableList"
            :columns="tableColumns"
          ></Table>
          <div class="paging_style">
            <Page size="small"
              :total="total"
              :page-size="query.pageSize"
              show-total
              @on-change="changePage"
              :current="query.pageNumber"
            ></Page>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right">
      <Button
        type="success"
        :disabled="selectedTaskItemIds.length===0"
        @click="handleSubmit"
      >确认配置</Button>
    </div>
  </div>
</template>

<script>
import { getResourceWithFile, setPicResource } from '@/api/msp/taskitem'
export default {
  data () {
    return {
      type: null,
      pictureTaskId: null,
      query: {
        resourceId: null,
        keyword: '',
        pageSize: 15,
        pageNumber: 1
      },
      tableList: [],
      total: 0,
      tableColumns: [
        { title: '所属站点', align: 'center', key: 'stationName' },
        { title: '资源编号', align: 'center', key: 'resourceCode' },
        { title: '资源类型', align: 'center', key: 'resourceTypeName' },
        {
          title: '上刊画面',
          align: 'center',
          render: (h, params) => {
            return h(
              'img',
              {
                domProps: {
                  src: params.row.fileKey + '?x-oss-process=image/resize,w_64'
                },
                on: {
                  click: () => {

                  }
                },
                style: {
                  width: '64px'
                }
              }
            )
          }
        },
        {
          title: '操作',
          align: 'center',
          render: (h, params) => {
            return h('a', {
              on: {
                click: () => {
                  this.pictureTaskId = this.pictureTaskId === params.row.taskitemId ? null : params.row.taskitemId
                }
              },
              style: { color: this.pictureTaskId === params.row.taskitemId ? '#ed4014' : '' }
            }, this.pictureTaskId === params.row.taskitemId ? '取消' : '选择')
          }
        }
      ]
    }
  },
  computed: {
    pictureSourceArray () {
      return this.$store.state.workOrder.pictureSourceArray
    },
    selectedTaskItemIds: {
      get () {
        return this.$store.state.workOrder.selectedTaskItemIds
      },
      set (val) {
        this.$store.commit('set_selected_task_item_ids', val)
      }
    }
  },
  methods: {
    changePictureSource (name) {
      if (parseInt(name) === 3) {
        this.getInstallResource()
      }
    },
    getInstallResource () {
      getResourceWithFile(this.query).then(res => {
        if (res && !res.errcode) {
          this.tableList = res.list
          this.total = res.totalRow
          this.query.pageNumber = res.pageNumber
        } else {
          this.tableList = []
          this.total = 0
          this.query.pageNumber = 1
        }
      })
    },
    handleSearch () {
      this.query.pageNumber = 1
      this.getInstallResource()
    },
    changePage (curPage) {
      this.query.pageNumber = curPage
      this.getInstallResource()
    },
    handleSubmit () {
      if (this.type === null) {
        this.$Notice.warning({ desc: '请选择一个画面来源' })
        return false
      }

      if (this.type === 3 && !this.pictureTaskId) {
        this.$Notice.warning({ desc: '请选择一个上刊中的画面' })
        return false
      }
      const postData = {
        taskitemIds: JSON.stringify(this.selectedTaskItemIds),
        type: this.type,
        fromTaskitemId: this.pictureTaskId
      }
      setPicResource(postData).then(res => {
        if (res && res.errcode === 0) {
          this.selectedTaskItemIds = []
          this.type = null
          this.$store.dispatch('getTaskItemData')
          this.$Notice.success({ desc: '操作成功' })
        }
      })
    }
  }
}
</script>
